import React from 'react';
import { NavBar, Footer } from '../components';
import {
  RecognitionHero,
  RecognitionImpact,
  RecognitionQuote
} from '../components/Recognition';

const AcademicChangemaker = () => {

  return (
    <div className="min-h-screen bg-white">
      <NavBar />
      <RecognitionHero />
      <RecognitionImpact />
      <RecognitionQuote />
      <Footer />
    </div>
  );
};

export default AcademicChangemaker;